import { useContext } from 'react';
import Image from '@next/image';

import { FilesContext } from '@providers/FilesProvider';
import { ConfigContext, getShopKey, ShopKey } from '@providers/ConfigProvider';
import Typography from '@components/atoms/Typography';
import { FormattedMessage, MessageDescriptor } from 'utils/intl';

import FooterContactUs from '../FooterContactUs';
import classes from './FooterDescription.module.scss';
import messages from './FooterDescription.messages';

export const textMap: Partial<Record<ShopKey, MessageDescriptor>> = {
  rugged: messages.rugged,
  // redarc: messages.redarc,
};

const FooterDescription = () => {
  const { shopId } = useContext(ConfigContext);
  const { getShopImageConfigs } = useContext(FilesContext);
  const [logo, background] = getShopImageConfigs(['footer-logo', 'footer-background']);

  const description = textMap[getShopKey(shopId)];

  return (
    <div className={classes.wrapper}>
      <div className={classes.box}>
        {logo && (
          <Image
            objectFit="contain"
            alt="logo"
            resolveConfig={{ ...logo, preset: 'svg' }}
            hasFade={false}
            hasLazyLoad={false}
            hasPreload={false}
            hasBlendMode={false}
          />
        )}
        {description && (
          <Typography variant="body2" className={classes.description}>
            <FormattedMessage {...description} />
          </Typography>
        )}
      </div>
      <div>
        <FooterContactUs />
      </div>
      {background && (
        <Image
          className={classes.background}
          objectFit="contain"
          alt="background"
          resolveConfig={{ ...background, preset: 'svg' }}
          hasFade={false}
          hasLazyLoad={false}
          hasPreload={false}
          hasBlendMode={false}
          width={376}
        />
      )}
    </div>
  );
};

export default FooterDescription;
